import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Outfit quiz — open / close. Occasion and budget are asked every time, not stored. */
export const useOutfitQuizStore = defineStore('outfitQuiz', () => {
  const isOpen = ref(false)
  /** Bumped on every open so the quiz starts clean and re-reads the profile. */
  const session = ref(0)

  function open() {
    session.value += 1
    isOpen.value = true
  }

  function close() {
    isOpen.value = false
  }

  return { isOpen, session, open, close }
})
